<template>
  <div>
    <md-content class="md-elevation-4 md-alignment-center-center card-meoempresas">
      <div class="middle-card">
        <div class="swal2-icon swal2-success">
          <div class="swal2-success-circular-line-left"></div>
          <span class="swal2-success-line-tip"></span>
          <span class="swal2-success-line-long"></span>
          <div class="swal2-success-ring"></div>
          <div class="swal2-success-fix"></div>
          <div class="swal2-success-circular-line-right"></div>
        </div>
      </div>
      <span class="md-title">{{ text }}</span>
    </md-content>
  </div>
</template>

<script>
export default {
  name: 'survey-complete',
  props: ['text'],
  mounted () {
    const element = this.$el.querySelector('.card-meoempresas')
    element.classList.add('animated', 'bounceIn')
  }
}
</script>

<style lang="scss" scoped>
.survey {
  margin: 10px;
}
.card-meoempresas {
  margin: auto auto;
  max-width: 1000px;
  min-height: 45vh;
}
.middle-card {
  padding-top: 10vh;
}
</style>
